import { memo } from "react";
import classNames from "classnames";
import { SimpleSelect, SimpleSelectProps } from "@tecorien/mimic";
import { AvailableFonts, AvailableFontsArray } from "../fonts";

import styles from "./styles.module.scss";

export type SignatureSelectorProps = Omit<SimpleSelectProps<AvailableFonts>, "options" | "isMulti"> & {
  optionText?: string
}

export const SignatureSelector = memo<SignatureSelectorProps>((
  {
    className,
    optionText,
    ...props
  }) => {
  return (
    <SimpleSelect
      className={classNames(styles.root, className)}
      options={AvailableFontsArray}
      formatOptionLabel={option => optionText ?? option.label}
      {...props}
      isMulti={false}
      styles={{
        option: (base, props) => {
          return {
            ...base,
            fontFamily: props.data.value,
            fontSize: 45,
          };
        },
        singleValue: (base, props) => {
          return {
            ...base,
            lineHeight: "60px",
            height: 60,
            fontFamily: props.data.value,
            fontSize: 45,
          };
        },
        ...props.styles,
      }}
    />
  );
});

export default SignatureSelector;